declare namespace $ {

	export class $bog_fragile_demo_retype_child1 extends $bog_fragile_demo_retype_base1 {
		limit( ): number
	}
	
}

//# sourceMappingURL=child1.view.tree.d.ts.map